import dayjs from 'dayjs'

export function getMonthsNames(locale: string | undefined, format = 'MMM') {
    const names = []
    const date = new Date(2021, 0, 1)

    for (let i = 0; i < 12; i += 1) {
        const month = dayjs(date)
        const localizedMonth = locale ? month.locale(locale) : month

        names.push(localizedMonth.format(format))
        date.setMonth(date.getMonth() + 1)
    }

    return names
}
